export default function getApiBaseUrl() {
  // https://property-tax-api.yourwayhome.com
  return import.meta.env.DEV
    ? 'http://localhost:8080'
    : 'https://property-tax-api.yourwayhome.com';
}
